import { RootState } from "@/store/store";
import { languageEndpointSelector } from "@/store/language-select/selectors/languageEndpointSelector";

export const languageLoadingSelector = (state: RootState) => {
  return languageEndpointSelector(state)?.isLoading;
};
